import React, { createContext, useEffect, useState } from 'react';

import { getListViewState } from './utils';

import { CHOICES_DROPDOWN_ACTIVE } from '../routes/admin/utils/DropdownItems';

export const CentralKitchenRecipeContext = createContext({});

export const CentralKitchenRecipeProvider = ({ children }) => {
  const listViewStates = getListViewState();

  // Applied filters
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(CHOICES_DROPDOWN_ACTIVE()[0]);
  const [customParams, setCustomParams] = useState({});

  // Advanced filters
  const [advancedFilters, setAdvancedFilters] = useState([]);

  useEffect(() => {
    listViewStates.setCurrentPage(1);
  }, [selectedBrands, selectedStatus, customParams, advancedFilters]);

  return (
    <CentralKitchenRecipeContext.Provider
      value={{
        ...listViewStates,
        selectedBrands,
        setSelectedBrands,
        selectedStatus,
        setSelectedStatus,
        customParams,
        setCustomParams,
        advancedFilters,
        setAdvancedFilters,
      }}
    >
      {children}
    </CentralKitchenRecipeContext.Provider>
  );
};

export default CentralKitchenRecipeContext;
